import { render, staticRenderFns } from "./choose-one.vue?vue&type=template&id=01839c1e&lang=pug&"
import script from "./choose-one.vue?vue&type=script&lang=js&"
export * from "./choose-one.vue?vue&type=script&lang=js&"
import style0 from "./choose-one.vue?vue&type=style&index=0&lang=stylus&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "choose-one.vue"
export default component.exports